import {
    useRef,
    useState,
} from 'react'
import {
    noop,
} from 'lodash'

import TableActionsContext, {
    BatchActionData,
    TableActionsContextValue,
} from './TableActionsContext'

const useCreateTableActionsStore = (): TableActionsContextValue => {
    const [
        batchActionData,
        setBatchActionData,
    ] = useState<BatchActionData>(null)

    const invalidateTableDataRef = useRef<() => void>(noop)

    return {
        batchActionData,
        setBatchActionData,
        invalidateTableDataRef,
    }
}

const TableActionsProvider = ({
    children,
}: Readonly<{
    children: JSX.Element | JSX.Element[],
}>) => {
    const value = useCreateTableActionsStore()

    return (
        <TableActionsContext.Provider value={value}>
            {children}
        </TableActionsContext.Provider>
    )
}

export default TableActionsProvider
